/**
 * Hardware Secure All Robustness.
 *
 * @group DRM
 *
 * @beta
 */
export const HW_SECURE_ALL = 'HW_SECURE_ALL';
